import { useState } from 'react';
import KardexList from './List.jsx';
import KardexDetail from './Detail.jsx';
import KardexAdjustForm from './Form.jsx';

export default function KardexPage() {
  const [view, setView] = useState('list');
  const [selectedContext, setSelectedContext] = useState(null);
  const [adjustProduct, setAdjustProduct] = useState('');
  const [refreshKey, setRefreshKey] = useState(0);

  const handleBack = () => {
    setView('list');
    setSelectedContext(null);
    setAdjustProduct('');
    setRefreshKey((value) => value + 1);
  };

  if (view === 'detail') {
    return <KardexDetail context={selectedContext} onBack={handleBack} />;
  }

  if (view === 'adjust') {
    return <KardexAdjustForm productoId={adjustProduct} onCancel={handleBack} onSaved={handleBack} />;
  }

  return (
    <KardexList
      refreshKey={refreshKey}
      onViewDetalle={(ctx) => {
        setSelectedContext(ctx);
        setView('detail');
      }}
      onAdjust={(productoId) => {
        setAdjustProduct(productoId || '');
        setView('adjust');
      }}
    />
  );
}
